import { get } from "@ember/object"

export default function (_payload, models, verb = "edited") {
  let to = [`planbook-edits:planbook-${models.planbookId}`]
  if (models.courseId) {
    to.push(`course-edits:course-${models.courseId}`)
  }

  let user = models.user || {}

  return {
    actor: `user-${user.id}`,
    verb: verb,
    object: `lesson-${get(models, "cardStack.id")}`,
    to: to,
  }
}
